import gsap from "gsap";
import Flip from "gsap/Flip";

gsap.registerPlugin(Flip);

class Filter {

  constructor(selector) {

    let self = this;

    this.filterWraps = document.querySelectorAll(selector);

    this.filterWraps.forEach(filterWrap => {

      let filters = filterWrap.querySelectorAll('.filter');

      filters.forEach(filter => {

        let select = filter.querySelector('select');

        if(select.querySelectorAll('option').length < 3) {
          filter.remove();
        }

        select.addEventListener('change', function() {

          self.handleSelect(filter);
          self.handleFilter(true);

        });

        self.handleSelect(filter);

      });

    });

    self.handleFilter(false);

  }

  handleSelect(filter) {

    let label = filter.querySelector('.filter__label span');
    let select = filter.querySelector('select');
    let selectedOption = select.options[select.selectedIndex];

    if(selectedOption.value) {
      label.innerHTML = selectedOption.innerHTML;
      filter.classList.add('filter--active');
    }
    else {
      label.innerHTML = label.dataset.empty;
      filter.classList.remove('filter--active');
    }

  }

  handleFilter(animation) {

    let duration = animation ? 0.5 : 0;

    this.filterWraps.forEach(filterWrap => {

      let filters = filterWrap.querySelectorAll('.filter');
      let empty = filterWrap.querySelector('.empty');
      let itemsToFilter = document.querySelectorAll(filterWrap.dataset.filterSelector);
      let itemsState = Flip.getState([itemsToFilter, empty]);
      let parent = itemsToFilter[0].parentNode;
      let startHeight = gsap.getProperty(parent, 'height');
      
      let url = document.documentElement.dataset.url;

      filters.forEach(filter => {

        let filterID = filter.dataset.filter;
        let select = filter.querySelector('select');
        let value = select.options[select.selectedIndex].value;

        if(value) {

          url += '/' + filterID + ':' + value;

          itemsToFilter.forEach(item => {

            let filtered = true;
            let filterValues = item.dataset[filterID].split(', ');

            filterValues.forEach(filterValue => {
              if(filterValue == value) {
                filtered = false;
              }
            })

            if(filtered) {
              item.classList.add('filtered-' + filterID);
            }
            else {
              item.classList.remove('filtered-' + filterID);
            }
      
          });

        }
        else {

          itemsToFilter.forEach(item => {
            item.classList.remove('filtered-' + filterID);
          });

        }

      });

      url += '/';

      history.pushState(null, null, url);

      if(filterWrap.querySelectorAll(filterWrap.dataset.filterSelector + ':not(.filtered-filter1,.filtered-filter2,.filtered-filter3)').length == 0) {
        empty.classList.add('visible');
      }
      else {
        empty.classList.remove('visible');
      }

      let endHeight = gsap.getProperty(parent, 'height');

      Flip.from(itemsState, {
        duration,
        ease: 'power1.inOut',
        absolute: true,
        onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1, ease: 'power1.inOut', duration}),
        onLeave: elements => {
          gsap.timeline()
            .set(elements, {
              display: 'flex'
            })
            .fromTo(elements,
              {
                opacity: 1,
              },
              {
                opacity: 0,
                ease: 'power1.inOut',
                duration
              }
            )
            .set(elements, {
              clearProps: 'all'
            })
          }
      });

      gsap.fromTo(parent, {
        height: startHeight,
      }, {
        height: endHeight,
        duration,
        ease: 'power1.inOut',
        clearProps: 'all',
      })

    });

  }

}

export default Filter;